import React, { useEffect, useState } from "react";
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  useNavigate,
} from "react-router-dom";

// import Icons
import "bootstrap-icons/font/bootstrap-icons.css";
import "remixicon/fonts/remixicon.css";

import "popper.js";
// import Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import "./App.css";

/** import all components */
//import Login2 from "./../client 2/src/components/Login";

//import Username from "./components/Username";
import Reset from "./components/Reset";
import Register from "./components/Register";
import Recovery from "./components/Recovery";
import Profile from "./components/Profile";
import Password from "./components/Password";
import PageNotFound from "./components/PageNotFound";

//** auth middleware */
import { AuthorizeUser, ProtectRoute } from "./middleware/auth";

import ProtoApp from "./components/proto/App";
import toast, { Toaster } from "react-hot-toast";
import { useAuthStore } from "./store/store";
import { USER_NOT_ACTIVE, USER_OUT_OF_SCHEDULE } from "./constants/errorCodes";
import Login2 from "./components/proto/components/Login/Login";
import Dashboard from "./components/proto/components/Dashboard/Dashboard";

// https://stackoverflow.com/questions/75785717/i-am-using-createbrowserrouter-what-is-the-proper-way-to-have-header-and-footer

function Layout() {
  const navigate = useNavigate();
  const [fireLogout, setFireLogout] = useState(false);

  useEffect(() => {
    // algunas veces le gana el evento al suscribe
    const inLogoutMode = useAuthStore.getState().inLogoutMode;
    if (inLogoutMode) {
      setFireLogout(true);
    }

    const logoutHandle = useAuthStore.subscribe(
      (state) => state.inLogoutMode,
      (value, prevValue) => {
        if (value && prevValue === false) {
          // TODO fix  setFireLogout(true);
          setTimeout(() => {
            userLogout();
          }, 100);

          useAuthStore.setState({ inLogoutMode: false });
        }
      }
    );

    useAuthStore.setState({ inLogoutMode: false });

    const subsErrorInfoStatus = useAuthStore.subscribe(
      (state) => state.errorInfoStatus,
      (newCount, prevCount) => {
        console.log(`errorInfoStatus changed: ${newCount}`);
        manageErrorInfoStatus1(newCount, prevCount);
      }
    );

    const subsErrorInfoStatusData = useAuthStore.subscribe(
      (state) => state.errorInfoStatusData,
      (newCount, prevCount) => {
        console.log(`errorInfoStatusData changed: ${newCount}`);
        manageErrorInfoStatusData1(newCount, prevCount);
      }
    );

    //const subsErrorInfoStatus = useAuthStore.subscribe(manageErrorInfoStatus);

    return () => {
      //  console.log("===>> XXXX");
      subsErrorInfoStatusData();
      subsErrorInfoStatus();
      logoutHandle();
    };
  }, []);

  useEffect(() => {
    if (fireLogout !== true) return;

    userLogout();
  }, [fireLogout]);

  //const errorInfoStatus = useAuthStore((state) => state.errorInfoStatus);
  //const reset = useAuthStore((state) => state.reset);

  function manageErrorInfoStatus1(info, prevInfo) {
    console.log("--->> ZZZAA ");
    if (Object.keys(info).length > 0) {
      toast.error(info);
    }
  }

  function manageErrorInfoStatusData1(info, prevInfo) {
    console.log("--->> ZZZAA ");

    if (Object.keys(info).length > 0) {
      if (info.esError) {
        if (
          info.codigoError === USER_OUT_OF_SCHEDULE ||
          info.codigoError === USER_NOT_ACTIVE
        ) {
          userLogout();
          toast.error(info.mensaje);
        }

        useAuthStore.setState({ errorInfoStatusData: {} });
      }
    }
  }

  function manageErrorInfoStatus(info, prevInfo) {
    console.log("--->> ZZZAA ");
    if (
      info.errorInfoStatus.length > 0 &&
      prevInfo.errorInfoStatus.length === 0
    ) {
      toast.error(info.errorInfoStatus);
    }

    if (
      Object.keys(info.errorInfoStatusData).length > 0 &&
      Object.keys(prevInfo.errorInfoStatusData).length === 0
    ) {
      const data = info.errorInfoStatusData;
      if (data.esError) {
        if (
          data.codigoError === USER_OUT_OF_SCHEDULE ||
          data.codigoError === USER_NOT_ACTIVE
        ) {
          userLogout();
          toast.error(data.mensaje);
        }

        useAuthStore.setState({ errorInfoStatusData: {} });
      }
    }
  }

  // logout handler function
  async function userLogout() {
    //  setTimeout(() => {
    await localStorage.removeItem("token");
    navigate("/Login"); //, { replace: true });
    //  }, 1000);
  }

  return (
    <>
      <Outlet />
    </>
  );
}

const routerBasename = window.env?.VARS_ROUTER_BASENAME ?? "";

/** root routes */
const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Login2 />,
      },
      /*{
    path: "/",
    element: <Username></Username>,
  },*/
      {
        path: "/register",
        element: <Register></Register>,
      },
      {
        path: "/password",
        element: (
          <ProtectRoute>
            <Password />
          </ProtectRoute>
        ),
      },
      {
        path: "/reset",
        element: <Reset></Reset>,
      },
      {
        path: "/profile",
        element: (
          <AuthorizeUser>
            <Profile />
          </AuthorizeUser>
        ),
      },
      {
        path: "/recovery",
        element: <Recovery></Recovery>,
      },
      {
        path: "/login",
        element: <Login2></Login2>,
      },
      {
        path: "/dashboard",
        element: <Dashboard></Dashboard>,
      },
      {
        path: "/protoApp",
        element: <ProtoApp />,
      },
      {
        path: "*",
        element: <PageNotFound></PageNotFound>,
      },
    ],
  },
],
  {
    basename: routerBasename, // Critical: leading slash, NO trailing slash
  },);

//const messaging = getMessaging();

export default function App() {
  //const env = process.env.REACT_APP_ENV ?? "";
  //const backendUrl = window.env?.BACKEND_URL;
  const env = window.env?.VARS_ENV_MODE ?? "";

  useEffect(() => {
    /*  const logoutHandle = useAuthStore.subscribe(
      (state) => state.inLogoutMode,
      (value, prevValue) => {
        console.log(`-->> logoutHandle FOUND: ${value}`);
        if (value && prevValue === false) {
          //setFireLogout(true);

          setTimeout(() => {
            userLogout();
          }, 500);

          useAuthStore.setState({ inLogoutMode: false });
        }
      }
    );

    async function userLogout() {
      //  setTimeout(() => {
      //  await localStorage.removeItem("token");
      //  navigate("/Login"); //, { replace: true });
      //  }, 1000);
    }

    useAuthStore.setState({ inLogoutMode: false });
*/
    //const subsErrorInfoStatus = useAuthStore.subscribe(manageErrorInfoStatus);

    return () => {
      //  logoutHandle();
    };
  }, []);

  return (
    <main>
      {/*  <link
        rel="stylesheet"
        type="text/css"
        href="./components/proto/components/rSlider/rSlider.css"
      ></link>*/}

      {env.length > 0 && (
        <div
          style={{
            zIndex: 5555,
            position: "fixed",
            top: 0,
            width: "300px",
            backgroundColor: "black",
            color: "red",
            textAlign: "center",
            left: 0,
            right: 0,
            marginLeft: "auto",
            marginRight: "auto",
            opacity: "0.5",
          }}
        >
          Env: <span style={{ fontWeight: "bold" }}>{env}</span>
        </div>
      )}

      <Toaster position="top-center" reverseOrder={false}></Toaster>
      <RouterProvider router={router}></RouterProvider>
    </main>
  );
}
